/**
 * Darken a hex color by a fixed amount (0-255).
 * @param {string} hex - Hex color e.g. "#10b981" or "10b981"
 * @param {number} amount - Amount to darken (positive number, e.g. 20)
 * @returns {string} Darkened hex color with #
 */
export function darkenHex(hex, amount = 25) {
  if (!hex || typeof hex !== "string") return "#059669";
  let col = hex.startsWith("#") ? hex.slice(1) : hex;
  if (col.length !== 6 && col.length !== 3) return hex;
  if (col.length === 3) {
    col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2];
  }
  const num = parseInt(col, 16);
  if (Number.isNaN(num)) return hex;
  const r = Math.max(0, (num >> 16) - amount);
  const g = Math.max(0, ((num >> 8) & 0xff) - amount);
  const b = Math.max(0, (num & 0xff) - amount);
  return `#${(0x1000000 + r * 0x10000 + g * 0x100 + b).toString(16).slice(1)}`;
}
